import React, { useState } from 'react';
import { useEffect } from 'react';
import General from "../../stores/GeneralStore";


const cardStyles: React.CSSProperties = {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    padding: '24px',
    maxWidth: '400px',
    margin: '20px auto',
    textAlign: 'center',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#fff',
    marginTop:'5rem'
};

const headingStyles: React.CSSProperties = {
    margin: '0 0 16px 0',
    color: General.ColorAss,
};

const textStyles: React.CSSProperties = {
    margin: 0,
    color: '#666',
};

const EmailVerification = () => {

    const [message,setMessage] = useState<string>("");

    useEffect(() => {
        const verifyEmail = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            const username = params.get('username');
            const data = { code, username };
            const response = await General.emailVerifyCodeForRegistration({ errorId: "emailVerifyCodeForRegistration", data });
            if (response) {
                setMessage("cm_emailverificationsuccessmes")
            }
            else {
                setMessage("cm_emailverificationfailedsmes")
            }
            
        };

        verifyEmail();

        // You can now use the code and username variables.
        // For example, you might want to send them to your backend for verification.
        
    }, []);
    return (
        <div style={cardStyles}>
            <h2 style={headingStyles}>{General.codeLabels["cm_emailverificationheader"]?.label || "Email Verification" }</h2>
            <p 
            className={General?.textClass}
            style={{ 
                fontSize: `${0.8 * General.accessibility.fontSize}rem`,
                color: General.ColorAss
            }}
            >
            {General?.codeLabels[message]?.label || "Email Has Been Successfully Verified. Please Login" }
            </p>
        </div>
    );
};

export default EmailVerification;